import React, { useEffect, useState } from 'react';
import { ApiController } from 'apiServices/apiController';
import { useParams } from 'react-router-dom';
import { CourseResultModel } from 'apiServices/controllers/course';
import { CourseOverview } from './course-overview';

type CourseOverviewAjaxFetch = {
  isFetched: boolean;
  loading: boolean;
  error: boolean;
  data: CourseResultModel | null;
};

export const CourseOverviewAjax = () => {
  const { id }: any = useParams();
  const [{
    isFetched, loading, error, data,
  }, setCursusAjaxFetch] = useState<CourseOverviewAjaxFetch>({
    isFetched: false,
    loading: true,
    error: false,
    data: null,
  });

  useEffect(() => {
    if (!isFetched) {
      setCursusAjaxFetch((prev) => ({ ...prev, isFetched: true }));

      try {
        const fetchCourse = async () => {
          const response = await ApiController.Course.getCourseById(id);

          return setCursusAjaxFetch({
            isFetched: true,
            loading: false,
            error: false,
            data: response,
          });
        };

        fetchCourse();
      } catch (error) {
        setCursusAjaxFetch({
          isFetched: true, loading: false, error: true, data: null,
        });
      }
    }
  }, [isFetched, id]);

  if (loading || !data) {
    return <>Laden...</>;
  }

  if (error) {
    return <>Kon cursus niet ophalen</>;
  }

  return <CourseOverview dataObject={data} />;
};
